import React from 'react';

const BackgroundEffects = ({ isLight }) => {
  if (isLight) {
    return (
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04] flex w-full h-full">
          <div className="w-[12%] h-full border-r border-primary"></div>
          <div className="w-[38%] h-full border-r border-primary"></div>
          <div className="w-[30%] h-full border-r border-primary"></div>
          <div className="w-[20%] h-full"></div>
        </div>
        <div className="absolute -top-[20%] -right-[10%] w-[800px] h-[800px] bg-primary/5 blur-[120px] rounded-full opacity-60"></div>
        <div className="absolute -bottom-[10%] -left-[10%] w-[600px] h-[600px] bg-accent/5 blur-[100px] rounded-full opacity-40"></div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] flex w-full h-full">
        <div className="w-[12%] h-full border-r border-white"></div>
        <div className="w-[38%] h-full border-r border-white"></div>
        <div className="w-[30%] h-full border-r border-white"></div>
        <div className="w-[20%] h-full"></div>
      </div>
      <div className="absolute inset-0 opacity-[0.03] flex flex-col w-full h-full">
        <div className="h-[20%] w-full border-b border-white"></div>
        <div className="h-[60%] w-full border-b border-white"></div>
        <div className="h-[20%] w-full"></div>
      </div>

      <div className="absolute -top-[20%] -right-[10%] w-[800px] h-[800px] bg-primary/20 blur-[120px] rounded-full opacity-40"></div>
      <div className="absolute -bottom-[10%] -left-[10%] w-[600px] h-[600px] bg-[#3b2d63]/30 blur-[100px] rounded-full opacity-30"></div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(18,16,33,0)_50%,rgba(0,0,0,0.25)_50%),linear-gradient(90deg,rgba(255,0,0,0.06),rgba(0,255,0,0.02),rgba(0,0,255,0.06))] bg-[size:100%_2px,3px_100%] pointer-events-none opacity-10"></div>
    </div>
  );
};

export default BackgroundEffects;
